module.exports = __webpack_public_path__ + "img/IND-B-2-I.36fb312e.png";